import React, { forwardRef, ReactNode, Ref } from 'react';
import { Tooltip } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import styles from './CustomTooltip.module.scss';

interface Props {
  error: any;
  children: ReactNode;
}

const CustomTooltip = forwardRef(
  ({ error, children }: Props, ref: Ref<HTMLDivElement>) => {
    return (
      <Tooltip
        placement="topLeft"
        title={
          error.message ? (
            <span className={styles.tooltip}>
              <WarningOutlined className={styles.tooltip__icon} />
              {React.createElement(
                'span',
                { className: styles.tooltip__text },
                error.message,
              )}
            </span>
          ) : (
            ''
          )
        }
        color="white"
      >
        <div ref={ref}>{children}</div>
      </Tooltip>
    );
  },
);

export default CustomTooltip;
